import { MockLoginDialog } from "./MockLoginDialog";
export default MockLoginDialog;
export * from "./MockLoginDialog";
